import { Component, OnInit } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";

@Component({
  selector: "krefield-password",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <input nz-input disabled />
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <!--   <input
          nz-input
          autocomplete="off"
          [formControl]="formControl"
          [kreFormAttributes]="field"
          [class.is-invalid]="showError"
          [type]="'password'"
        />-->

        <nz-input-group [nzSuffix]="suffixTemplate">
          <input
            [type]="passwordVisible ? 'text' : 'password'"
            nz-input
            autocomplete="off"
            [formControl]="formControl"
            [kreFormAttributes]="field"
            [class.is-invalid]="showError"
          />
        </nz-input-group>
        <ng-template #suffixTemplate>
          <i
            nz-icon
            [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
            (click)="passwordVisible = !passwordVisible"
          ></i>
        </ng-template>
      </ng-container>

      <div class="fieldtext" *ngIf="editor === false">
        {{ text }}
      </div>
    </ng-template>
  `,
})
export class KreFormFieldPassWord extends FieldType implements OnInit {
  passwordVisible = false;
  // password = "";
  // read = true;
  ngOnInit() {
    // this.password = new Array(this.text.length).fill("*").join("");
  }
  // clickRead() {
  //   this.read = !this.read;
  //   if (this.read) {
  //     this.password = new Array(this.text.length).fill("*").join("");
  //   } else {
  //     this.password = this.text;
  //   }
  // }
  // <div class="text">
  //   {{ password }}
  // </div>
  // <div class="read">
  //   <i
  //     nz-icon
  //     [nzType]="read ? 'eye-invisible' : 'eye'"
  //     (click)="clickRead()"
  //   ></i>
  // </div>
}
